function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5706 4.2689C9.97545 4.43556 8.27676 4.3724 6.01431 4.05497C6.0205 3.09935 6.15552 2.27087 6.37652 2H14.3899C14.3009 2.65766 14.2204 3.25359 14.1473 3.79621C13.2483 4.02678 12.4118 4.18103 11.5706 4.2689Z",
  fill: "#2E8E16"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9862 8.24725C12.5237 8.1911 13.0532 8.11381 13.5823 8.01605C13.3205 9.97187 13.2168 10.7076 12.7872 13.5789C12.2099 17.4371 16.6213 18.4166 19.1979 18.4166C21.7744 18.4166 21.3273 21.5636 19.6096 22H7.46715C7.46715 22 6.91074 21.3729 7.46715 18.8421C7.67187 17.911 7.83006 17.3709 7.93544 17.0111C8.11648 16.3931 8.14168 16.3071 7.97919 15.6842C7.79092 14.9625 7.56237 13.4573 7.32002 11.8613C7.12387 10.5696 6.91869 9.21833 6.71852 8.17481C8.63908 8.38631 10.3213 8.42119 11.9862 8.24725Z",
  fill: "#2E8E16"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3066 6.23274C17.8369 6.07873 18.142 5.52392 17.988 4.99354C17.834 4.46317 17.2792 4.15807 16.7488 4.31208C16.464 4.39478 16.187 4.47289 15.9168 4.54643C15.3839 4.69147 15.0695 5.24104 15.2145 5.77394C15.3596 6.30684 15.9091 6.62127 16.442 6.47624C16.7243 6.39942 17.0122 6.31822 17.3066 6.23274Z",
  fill: "#2E8E16"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7868 7.09297C14.33 6.99303 14.6893 6.47168 14.5894 5.92852C14.4894 5.38535 13.9681 5.02605 13.4249 5.12599C12.8569 5.23051 12.3086 5.30899 11.7659 5.36174C11.2162 5.41518 10.8139 5.90411 10.8674 6.4538C10.9208 7.0035 11.4097 7.40579 11.9594 7.35236C12.5637 7.29362 13.1683 7.20678 13.7868 7.09297Z",
  fill: "#2E8E16"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9.17803 7.42242C9.72975 7.44732 10.1972 7.02024 10.2221 6.46851C10.247 5.91679 9.8199 5.44935 9.26817 5.42445C8.73202 5.40026 8.17731 5.3525 7.59192 5.28021C7.0438 5.21252 6.54458 5.60199 6.4769 6.15011C6.40921 6.69823 6.79867 7.19744 7.34679 7.26513C7.97858 7.34315 8.58519 7.39567 9.17803 7.42242Z",
  fill: "#2E8E16"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M4.66515 6.819C5.20647 6.92851 5.73406 6.57845 5.84357 6.03713C5.95307 5.49581 5.60301 4.96821 5.06169 4.85871C4.78704 4.80315 4.50504 4.74351 4.21489 4.67974C3.67548 4.56117 3.14209 4.90234 3.02353 5.44174C2.90496 5.98115 3.24613 6.51454 3.78554 6.63311C4.0857 6.69908 4.37867 6.76105 4.66515 6.819Z",
  fill: "#2E8E16"
});

var SvgPerimetroPanturrilhaFilled = function SvgPerimetroPanturrilhaFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPerimetroPanturrilhaFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/perimetro-panturrilha-filled.a34c3878.svg";
export { ForwardRef as ReactComponent };